import { useNavigate } from "react-router-dom"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { useAuth, UserType } from "@/hooks/useAuth"
import VideoBackground from "@/components/VideoBackground"
import { useLanguage } from "@/hooks/useLanguage"
import { SEO } from "@/components/SEO"
import { FeaturedCategories } from "@/components/marketing/FeaturedCategories"
import { FeaturedProducts } from "@/components/marketing/FeaturedProducts"

const Index = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { t, language } = useLanguage()
  const text = t.index

  const isSoftLaunch = import.meta.env.VITE_SOFT_LAUNCH === "true"
  const canAccessEcommerce = !isSoftLaunch || user?.userType === UserType.Admin

  return (
    <div className="min-h-screen bg-background">
      <SEO title={t.seo.homeTitle} description={t.seo.homeDesc} />
      <Header />

      <main>
        {/* Hero Section with Video Background */}
        <section className="relative flex h-[85vh] w-full items-center justify-center overflow-hidden">
          <VideoBackground />

          {/* Content Layer */}
          <div className="container relative z-20 mx-auto px-4 text-center">
            <h1 className="mb-6 text-5xl font-bold text-white drop-shadow-2xl md:text-7xl">
              {text.hero.title}
            </h1>
            <p className="mx-auto mb-12 max-w-3xl text-xl text-white/90 drop-shadow-md md:text-2xl">
              {text.hero.subtitle}
            </p>
            <div className="mt-8 flex justify-center gap-4">
              <Button
                onClick={() => navigate(canAccessEcommerce ? "/catalog/marketplace" : "/contact")}
                className="flex items-center justify-center gap-3 rounded-full border-2 border-primary bg-white px-12 py-8 text-2xl font-bold text-primary shadow-2xl transition-all duration-300 hover:scale-105 hover:bg-primary hover:text-white"
              >
                <span className="lowercase">{canAccessEcommerce ? text.hero.shopNow : t.header.contact}</span>
                <ArrowRight className="h-6 w-6" />
              </Button>
            </div>
          </div>
        </section>

        {canAccessEcommerce && (
          <>
            {/* Featured Categories Carousel Section */}
            <FeaturedCategories />

            {/* Top Items Carousel Section */}
            <FeaturedProducts />
          </>
        )}
      </main>

      <Footer />
    </div>
  )
}
export default Index

